// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-parent{height:100%;width:100%;overflow:hidden;position:relative}.scroll-child{min-width:100%;position:absolute;top:0;bottom:0;left:0;overflow-y:auto;overflow-x:hidden}@media (max-width: 768px){.scroll-child{overflow-y:scroll;-webkit-overflow-scrolling:touch}}\n", ""]);
// Exports
module.exports = exports;
